import { useCallback } from 'react';

import {
  SubscriptionEvent,
  useReadingsStream,
} from '@/hooks/query-hooks/streams/gaia-api/use-readings-stream';
import { Reading, readingsStreamQuery } from '@/queries/gaia-api/readings-stream-query';
import { GaiaQueryWithAgentId } from '@/queries/types';

import { SubscriptionIdentifier, useSubscriptionBase } from './use-subscription-base';

interface UseReadingsProps extends GaiaQueryWithAgentId {
  readingIds?: SubscriptionIdentifier[];
}

/**
 * Subscribe to readings stream with given readingIds and get back mapped results
 *
 * @param agentId The agent ID
 * @param readingIds The list of point IDs to subscribe to
 * @returns The active alarm activations for this Agent.
 */
export const useReadingsSubscription = ({ agentId, readingIds }: UseReadingsProps) => {
  const { enabled, queryKey } = readingsStreamQuery({ agentId });
  const { sendContent, isConnected } = useReadingsStream();
  const handleSendContent = useCallback(
    (subscriptionIds: string[]) => {
      if (isConnected && subscriptionIds.length > 0) {
        sendContent({
          point_ids: subscriptionIds,
        } as SubscriptionEvent);
      }
    },
    [sendContent, isConnected]
  );

  return useSubscriptionBase<Reading>({
    enabled: !!enabled,
    queryKey: queryKey as string[],
    isConnected,
    handleSendContent,
    subscriptionIds: readingIds,
  });
};
